module.exports = __webpack_public_path__ + "static/img/logo-white-transparent.c0343560.png";